/** 骨科 */

/** 对应的标题 */
const categoryMap = {
  HSS_score_of_knee: '膝关节HSS评分',
  Osteoporosis_Risk_One_Minute_Question:'骨质疏松症风险一分钟测试题',
  Osteoporosis_Self_Screening_Tool_for_Asians:"OSTA指数",
  Low_back_pain_surgical_scoring_criteria:"腰背痛手术评分标准",
  Mason_Classification_of_Radial_Head_Fractures:"桡骨头骨折Mason分类",
  Letournel_Judet_classification_of_acetabular_fractures:"髋臼骨折Letournel-Judet分型",
  Denis_classification_of_spinal_fractures:'脊柱骨折Denis分类',
  Modified_EIlis_Classification_of_Tibial_Fractures:"胫骨骨折改良EIlis分类",
  Eyres_Brooks_classification_of_scapular_coracoid_process:"肩胛骨喙突Eyres-Brooks分型",
  Radial_Head_Fractures_Hotchkiss_Classification:"桡骨头骨折Hotchkiss分类",
  Ferguson_classification_of_flexion_compression_fractures:'屈曲压缩骨折Ferguson分型',
  Elbow_HSS_score:"肘关节HSS评分",
  Clavicle_fracture_classification:'锁骨骨折分类',
  Schatzker_classification_of_tibial_plateau_fractures:'胫骨平台骨折Schatzker分型',
  Distal_Radius_Fracture_Grade:"桡骨远端骨折按关节面情况的分级",
  Distal_Radius_Fractures_Lidstrom_Scale:'桡骨远端骨折Lidstrom分度',
  Rockwood_classification_of_acromioclavicular_joint_dislocation:'肩锁关节脱位（Rockwood分类法）',
  Perilunate_dislocation_classification:'月骨周围脱位分型',
  Lateral_condyle_fracture_classification:'肱骨外髁骨折分型',
  Mechanism_classification_of_humeral_intercondylar_fracture:'肱骨髁间骨折分型',
  Neer_classification_of_proximal_humeral_fractures:'肱骨近端骨折Neer分类'

}
export default {
  categoryMap
}


// WEBPACK FOOTER //
// ./src/utils/category/Orthopaedics.js